<div class="dialog">
  <div class="dialog-header" [id]="widgetTitle">
    <img *ngIf="widgetIcon" [src]="widgetIcon" class="widget-icon" [alt]="widgetTitle">
    <span class="widget-title">{{widgetTitle}}</span>
    <span aria-label="Close" role="button" class="widget-close" (click)="closeWidget()">×</span>
  </div>
  <div class="dialog-content">
    <ng-content></ng-content>
  </div>
  <div class="dialog-footer">

  </div>
</div>
